import React, { useRef } from 'react';
var VeltNotificationsToolLabel = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-tool-label", { ref: ref }, children));
};
export default VeltNotificationsToolLabel;
